var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11_150",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11_150",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAACwUlEQVR4nO3dsWoUYRTF8XMliCAELOy0ELTQlLFI7MV9gVgo+AgW8QW0V9/BdkvFIgjBzqDRzk60SCUo4iLEInIssgEJ2ZlZ55v7nYTzq2fnDvlnZvfLzm4AMzMzMzMzMzOz4yEyh5G8DGAE4Gzm3Dl8B/AiIr7WPpDBkXxEco/6fpG8W+vnlHKGkLwH4FnGrEL2ANyIiHfZg08lzVlPmlPKAoD7NQZnBbmaNKekpRpDs4KcTppTUpVjzgpiHTmIGAcR4yBiHESMg4hxEDEOIsZBxDiIGAcR4yBiHESMg4hxEDFZb+EyY05hEwAbhfe5FRFPmzZYKDzwJFkEsJY91JcsMQ4ixkHEOIgYBxHjIGL8sne2/1mHrAK40Geog8y2ExG353kAyTF6rl18yRLjIGIcRIyDiHEQMQ4ixkHEOIgYBxHjIGIcRExWkN2kOSVVOeasINtJc0p6W2NoVpCHAP4kzSphAuBxjcEpQSJiE8AdAN8y5vX0CcAoIr7UGN76fgjJdQArDZu03vwFABExJvl8uq/z3Q/xSBcBPGnZ5gGAnTn2yen22xFR7Wzu8gbVCgrdMBYRvwG87rsfkktoD7IRER/7zsrml71iHESMg4hxEDEOIsZBxKQEIbmYMeckyDpDNkmeS5p1rGUFWQbwylHaZT6HOEoH2ff2LgN4SXIUEZOBZ10jeWbgGYf1/mWrcbP1KvafU25GxI8B54wH3Pdgar3s9eVrhprrEEc5Qu2FoaMcUiLIWtu/G2h5vKP8o/YZcsBRplSCAI4CQCsI4CiSH/q8AuASgKY1ymcA13MOp6jWdZdakAmAWxHxoWmjiNgF8D7nkHIpXbIOYmzVPpCaVII4xlTrN8qR7P3tBGj+u9IE+3cKvuk5w7pqWDP+JNl0V6QNwTHEOIYYxxDjGGIcQ4xjiJmuZczMzMzMzEzQX0KA3yEHww/HAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.b27bb61cdee7e19fe4e65ef8561732d4.svg";
export { ForwardRef as ReactComponent };